import PropTypes from 'prop-types';
import {get as _get} from 'lodash';

import {SPORTS_COURT_LIST} from '@constants/variables';
import {showCopyableIdTooltip} from '@utils/eventDetailsHelper';

import {convertToInt} from './helpers';
import {getSport} from './sport';

const VENUE = 'Venue';

/**
 * Display label for Venue/Court
 */
export const venueCourtLabel = (event) => {
    const eventSportId = convertToInt(getSport(event).id);

    return ((event.sr_event || event.st_event) && SPORTS_COURT_LIST.includes(eventSportId))
        ? 'Court'
        : VENUE;
};

venueCourtLabel.propTypes = {
    event: PropTypes.shape({
        sr_event: PropTypes.object,
    }).isRequired,
};

venueCourtLabel.defaultProps = {
    event: {
        sr_event: null,
    },
};

/**
 * Value for Venue/Court
 * @param event
 * @returns {string}
 */
export const venueCourtValue = (event) => {
    let venueCourtName,
        venueCourtId,
        city;

    /**
     * Sportradar
     */
    if (event.sr_event) {
        if (event._hasMatchID) {
            venueCourtName = _get(event.sr_event, 'match.stadium.name', '');
            venueCourtId = _get(event.sr_event, 'match.stadium.id', '');
            city = _get(event.sr_event, 'match.stadium.city.name', null);
        } else {
            venueCourtName = _get(event.sr_event, 'stadium.name', '');
            venueCourtId = _get(event.sr_event, 'stadium.id', '');
            city = _get(event.sr_event, 'stadium.city.name', null);
        }
    }
    /**
     * Non-sportradar event
     */
    else if (event.av_event) {
        venueCourtName = _get(event, 'av_event.venue.name', '');
        venueCourtId = _get(event, 'av_event.venue.id', '');
        city = _get(event, 'av_event.venue.city.name', null);
    }
    /**
     * Stage event
     */
    else if (event.st_event) {
        if (event.st_event.stage?.id) {
            venueCourtName = _get(event, 'stadiumWithCity.name', '');
            venueCourtId = _get(event, 'stadiumWithCity.id', '');
            city = _get(event, 'stadiumWithCity.city.name', '');
        } else {
            venueCourtName = _get(event.st_event, 'stadium.name', '');
            venueCourtId = _get(event.st_event, 'stadium.id', '');
            city = _get(event.st_event, 'stadium.city.name', '');
        }
    }

    const columnName = (event.sr_event || event.st_event) ? VENUE : 'AV venue';

    /**
     * If there is city, display in format "stadium/venue - city"
     */
    if (city) {
        const name = `${venueCourtName} - ${city}`;

        return venueCourtLabel(event) !== VENUE
            ? name
            : showCopyableIdTooltip(name, venueCourtId, columnName);
    } else {
        const name =`${venueCourtName || '-'}`;

        return venueCourtLabel(event) !== VENUE
            ? name
            : showCopyableIdTooltip(name, venueCourtId, columnName);
    }
};

venueCourtValue.propTypes = {
    event: PropTypes.shape({
        sr_event: PropTypes.shape({
            match: PropTypes.shape({
                stadium: PropTypes.shape({
                    city: PropTypes.shape({
                        name: PropTypes.string,
                    }),
                    id: PropTypes.number,
                    name: PropTypes.string,
                }),
            }),
        }),
        av_event: PropTypes.shape({
            venue: PropTypes.shape({
                city: PropTypes.shape({
                    name: PropTypes.string,
                }),
                name: PropTypes.string,
                id: PropTypes.number,
            }),
        }),
        st_event: PropTypes.shape({
            stage: PropTypes.shape({
                id: PropTypes.string,
            }),
            stadium: PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
                city: PropTypes.shape({
                    name: PropTypes.string,
                }),
            }),
        }),
        stadiumWithCity: PropTypes.shape({
            name: PropTypes.string,
            city: PropTypes.shape({
                name: PropTypes.string,
            }),
        }),
    }).isRequired,
};

venueCourtValue.defaultProps = {
    event: {
        sr_event: {
            match: {
                stadium: {
                    city: {
                        name: null,
                    },
                    name: null,
                },
            },
        },
        av_event: {
            venue: {
                city: {
                    name: null,
                },
                name: null,
            },
        },
        st_event: {
            stage: {
                id: null,
            },
            stadium: {
                name: null,
                city: {
                    name: null,
                },
            },
        },
        stadiumWithCity: {
            name: null,
            city: {
                name: null,
            },
        },
    },
};
